import { Priceable } from 'components/business/checkout/checkoutHooks';
import protos from 'utils/protos';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Discount } = protos;

export function isTotallyFreePurchase(purchase: Priceable) {
  return !isCreditCardCollectingPurchase(purchase) && extractSubtotal(purchase) === 0;
}

export function isCreditCardCollectingPurchase(purchase: Priceable) {
  return extractTotalPrice(purchase) > 0 || extractHoldPrice(purchase) > 0;
}

export function extractHoldPrice(purchase: Priceable) {
  const ticketPriceInformation = purchase?.ticketPriceInformation;
  if (ticketPriceInformation?.priceType !== 'PAYMENT_CARD_HOLD') {
    return 0;
  }
  return (ticketPriceInformation.amountCents ?? 0) * (purchase?.ticketCount ?? 0);
}

export function extractTotalPrice(purchase: Priceable) {
  return purchase?.totalPrice ?? 0;
}

export function extractSubtotal(purchase: Priceable) {
  return purchase?.subtotal ?? 0;
}

export function extractDiscounts(purchase: Priceable) {
  return (purchase.discount ?? [])
    .map((discount: typeof Discount) => discount.amountCents)
    .reduce((previous, current) => previous + current, 0);
}
